var lists_default = {
  "fontElementMap": "-wKoT",
  "orderedlist": "fcdgz",
  "bulletedlist": "PFjnR",
  "listItem": "_0x2oV"
};
export {
  lists_default as default
};
//# sourceMappingURL=lists-scss.js.map
